import { render, staticRenderFns } from "./ProductsWholesaleDiscountsShowEdit.vue?vue&type=template&id=9ba83cb8&lang=pug&"
import script from "./ProductsWholesaleDiscountsShowEdit.vue?vue&type=script&lang=js&"
export * from "./ProductsWholesaleDiscountsShowEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductsWholesaleDiscountsShowEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductsWholesaleDiscountsShowEdit.vue"
export default component.exports